module.exports = __webpack_public_path__ + "static/media/slide-1.5c433d86.jpg";